
import { UseFormRegister, UseFormWatch, UseFormSetValue } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { Application, CorporateStructure } from '@/types/database.types';

interface CompanyInformationProps {
  register: UseFormRegister<Partial<Application>>;
  watch: UseFormWatch<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
  data: Partial<Application>;
}

const CORPORATE_STRUCTURES: CorporateStructure[] = [
  'LLC',
  'S-Corp',
  'C-Corp',
  'Partnership',
  'Sole Proprietorship',
  'Non-Profit'
];

export const CompanyInformation = ({ register, watch, setValue, data }: CompanyInformationProps) => {
  const corporateStructure = watch('corporate_structure');

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="company_legal_name">Organization Legal Name</Label>
        <Input
          id="company_legal_name"
          {...register('company_legal_name')}
          placeholder="Enter legal organization name"
          className="bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="company_dba">DBA (Doing Business As)</Label>
        <Input
          id="company_dba"
          {...register('company_dba')}
          placeholder="Enter DBA name (if different)"
          className="bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="company_website">Organization Website</Label>
        <Input
          id="company_website"
          {...register('company_website')}
          placeholder="https://www.example.com"
          className="bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="ein">Federal EIN</Label>
        <Input
          id="ein"
          {...register('ein')}
          placeholder="XX-XXXXXXX"
          className="bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="year_founded">Year Founded</Label>
        <Input
          id="year_founded"
          {...register('year_founded')}
          placeholder="YYYY"
          className="bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="naics_code">NAICS Code</Label>
        <Input
          id="naics_code"
          {...register('naics_code')}
          placeholder="Enter NAICS code"
          className="bg-white"
        />
      </div>

      <div className="space-y-2 md:col-span-2">
        <Label htmlFor="corporate_structure">Corporate Structure</Label>
        <Select
          value={corporateStructure || ""}
          onValueChange={(value) => setValue('corporate_structure', value as CorporateStructure)}
        >
          <SelectTrigger className="w-full bg-white">
            <SelectValue placeholder="Select..." />
          </SelectTrigger>
          <SelectContent className="bg-white">
            {CORPORATE_STRUCTURES.map((structure) => (
              <SelectItem key={structure} value={structure}>
                {structure}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
